<template>
    <div>
        <template v-for="(item, index) in boxes">
            <gofix-card :key="index" :title="item.title" classHeader="mb-13" classContent="mb-0" v-if="job[item.key] && job[item.key].length">
                <signature :signatures="job[item.key]"></signature>
            </gofix-card>
        </template>
    </div>
</template>

<script>
    import Signature from './signature.vue';
    export default {
        name: 'detail-signature',
        components: {
            Signature
        },
        props: {
            job: {
                type: Object,
                default: () => {}
            },
            type: {
                type: String,
                default: '',
                required: false
            }
        },
        data() {
            return {
                boxes: [
                    { title: 'Submitted', key: 'submitted_signatures' },
                    { title: 'Acknowledged', key: 'acknowledged_signatures' },
                    { title: 'PM Acknowledged', key: 'pm_acknowledged_signatures' },
                    { title: 'Completed', key: 'completed_signatures' },
                    { title: 'Approved', key: 'approved_signatures' }
                ]
            }
        },
        created() {
            if(this.type && this.type == 'non-conformance') {
                this.boxes[1].title = 'Contractor Acknowledged';
            }
        },
        methods: {}
    }
</script>
